<template>
  <v-dialog
    v-model="show"
    persistent
    scrollable
    max-width="980px"
  >

    <v-card
      elevation="13"
      :key="componentKey"
    >
      <v-card-title class="header">{{ title }}</v-card-title>
      <template v-if="hasSubtitle">
        <v-card-subtitle class="tele2-subtitle">
          <slot name="subtitle"></slot>
        </v-card-subtitle>
      </template>
      <v-divider></v-divider>
      <v-card-text style="height: 80%;">
        <slot></slot>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <template v-if="!readonly">
          <v-btn
            color="primary"
            v-on:click="confirm"
            :loading="loading"
          >
            {{ saveActionCaption }}
          </v-btn>
          <v-btn
            :loading="loading"
            v-on:click="close()"
          >
            {{ cancelActionCaption }}
          </v-btn>
        </template>
        <template v-if="readonly">
          <v-btn
            :loading="loading"
            v-on:click="close()"
          >
            Close
          </v-btn>
        </template>
        <slot name="additionalActions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'ModalForm',
    props: {
      show: {
        default: false,
      },
      loading: {
        default: false,
      },
      title: {
        default: 'Title',
      },
      readonly: {
        default: false,
      },
      saveActionCaption: {
        default: 'Save',
      },
      cancelActionCaption: {
        default: 'Cancel',
      },
      hasSubtitle: {
        default: false,
      },
    },
    data: function () {
      return {
        componentKey: 0, // hack to always update model content
      }
    },
    watch: {
      show: function () {
        this.componentKey += 1
      },
    },
    methods: {
      close () {
        this.$emit('update:show', false)
      },
      confirm () {
        this.$emit('saveData', false)
      },
    },
  }
</script>

<style scoped>
  .v-dialog .v-card .v-card__title {
    font-weight: bold;
    text-align: left;
    padding: 15px;
    background-color: #e1e1e1;
  }

  .v-dialog .v-card .v-card__title.header {
    background-color: #2E76BF;
    color: white;
    font-weight: normal;
    font-size: 18px;
  }
  .v-dialog .tele2-subtitle {
    margin-top: 15px;
    background-color: white;
  }
</style>
